module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-6-dfff03e1.png";